import { Button, Card, Col, Input, message, Row } from 'antd'
import React, { useState, useEffect } from 'react'
import articleStyle from './article.module.less'
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import MarkDownEditor, {
  mdParser,
} from '../../../component/MarkDownEditor/MarkDownEditor'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../../api/http-request'

import {
  CheckCircleOutlined 
} from '@ant-design/icons'
import { setServers } from 'dns'

export interface Props {
  articleId:any
}


const ArticleFrom = (props) => {
  const location = useLocation()
  const history = useHistory()
  const createMode = location.pathname.split('-')[2] === 'create'
  const articleId = !createMode ? location.pathname.split('/')[2] : null
  const [articleTitle, setArticleTitle] = useState('')
  const [articleContent, setArticleContent] = useState('') // # aaa $(x^2 + x^y )^{x^y}+ x_1^2= y_1 - y_2^{x_1-y_1^2}$
  const [articleLoaded, setArticleLoaded] = useState(false) // 加载中
  const [uploadImageList, setUploadImageList] = useState([] as any [])

  const [savingStatus, setSavingStatus] = useState(false) // 加载中

  useEffect(() => {
    createMode ? queryArticleContent() : queryArticleContentById()
  }, [])

  const onTitleChange = (e) => {
    setArticleTitle(e.target.value)
  }

   /**
   * 发布文章
   */
   const publishArticle = () => {
    sendHttpPostRequest(
      'community/api/publish_post/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId
        // title: articleTitle,
        // content: articleContent
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/login?next=community'
        } else if (response.code == 0) {
          // 成功
          window.location.href = '/community'
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 存文章草稿内容
   */
  const saveArticleContent = () => {
    setSavingStatus(false)
    sendHttpPostRequest(
      'community/api/save_post_draft/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
        title: articleTitle,
        content: articleContent,
        upload_image_list: JSON.stringify(uploadImageList)
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/login?next=community'
        } else if (response.code == 0) {
          // 成功
         //message.success('草稿更新成功')
         if(createMode == false) {
          message.success('文章保存成功~')
         }
          setSavingStatus(true)
          setUploadImageList([])
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查询文章内容
   */
  const queryArticleContent = () => {
    setArticleLoaded(false)
    sendHttpPostRequest(
      'community/api/query_post_draft/',
      {
        sessionid: Cookies.get('sessionid'),
      },
      (response: any) => {
        setArticleLoaded(true)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/login?next=community'
        } else if (response.code == 0) {
          // 成功
          setArticleTitle(response.title)
          setArticleContent(response.content)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/login?next=community'
        } else if (response.code == -509) {
          // 未阅读社区协议
          window.location.href = '/community?tab=3'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查询文章内容by id
   */
  const queryArticleContentById = () => {
    setArticleLoaded(false)
    sendHttpPostRequest(
        'community/api/query_post_by_id/',
        {
          sessionid: Cookies.get('sessionid'),
          edit_mode: 2,
          post_id: articleId
        },
        (response: any) => {
          setArticleLoaded(true)
          message.destroy()
          if (response.code == -100) {
            // 未登录
            window.location.href = '/login?next=community'
          } else if (response.code == 0) {
            // 成功
            setArticleTitle(response.title)
            setArticleContent(response.content)
          } else if (response.code == -501) {
            // 权限不足
            window.location.href = '/login?next=community'
          } else if (response.code == -509) {
            // 未阅读社区协议
            window.location.href = '/community?tab=3'
          } else {
            message.error(response.message)
          }
        }
    )
  }

  const onEditorChange = ({ html, text }) => {
    setArticleContent(text)
  }

  const uploadOption = {
    name: "community_picture",
    actionUrl: "community/api/upload_picture/",
    uploadData: { sessionid: Cookies.get('sessionid') },
    uploadImageList: uploadImageList,
    setUploadImageList: setUploadImageList
  }

  return (
    <div className={articleStyle.articleMain}>
      <Card
        bodyStyle={{
          padding: '30px 60px 80px 60px',
          minHeight: '970px',
          height:'calc(100vh - 240px)'
        }}
        extra={
          <span style={{ cursor: 'pointer' }} onClick={() => history.goBack()}>
            {'返回>'}
          </span>
        }
        className={articleStyle.articleCard}
        title={createMode ? <>创建新文章 {savingStatus == true && <span style={{marginLeft:10, color:'#07c160'}}><CheckCircleOutlined /> <span style={{marginLeft:5, fontSize:14, color:'#666'}}>已保存 </span></span> }</>
         : <>编辑文章</>}
      >
        <Row className={articleStyle.row} align={'middle'} wrap={false}>
          <Col className={articleStyle.title}>标题</Col>
          <Col flex={'auto'}>
            <Input
              className={articleStyle.input}
              value={articleTitle}
              onChange={onTitleChange}
              onBlur={() => {
                //articleTitle != '' ? saveArticleContent() : ''
                if(createMode == true) {
                  articleTitle != '' ? saveArticleContent() : ''
                }
              }}
              placeholder={'请输入文章标题'}
              autoFocus
            />
          </Col>
        </Row>
        <Row className={articleStyle.row} align={'top'} wrap={false}>
          <Col className={articleStyle.title}>内容</Col>
          <Col className={articleStyle.editorContain}>
            <MarkDownEditor
              onChange={onEditorChange}
              onBlur={() => {
                //saveArticleContent()
                if(createMode == true) {
                  saveArticleContent()
                }
              }}
              preview
              toolbar={'all'}
              height='calc(100vh - 370px)'
              minHeight={850}
              value={articleContent}
              uploadOption={uploadOption}
            />
          </Col>
        </Row>
      </Card>
        <Row
        className={articleStyle.actionFooter}
        justify={'center'}
        align={'middle'}
      >
        <Col>
          <Button style={{color:'#07c160', border:'solid 1px #07c160', marginRight: '60px' ,  width:80, textShadow:'none', boxShadow:'none'}}  onClick={() => history.goBack()} >
            取消
          </Button>
        </Col>

        <Col>
          { createMode == true && 
            <Button  style={{width:80, textShadow:'none', boxShadow:'none'}} type={'primary'} onClick={publishArticle}>
              发布
            </Button> 
          }

          { createMode == false && 
            <Button  style={{width:80, textShadow:'none', boxShadow:'none'}} type={'primary'} onClick={saveArticleContent}>
              保存
            </Button> 
          }

        </Col>
      </Row>
    </div>
  )
}

export default ArticleFrom
